import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store/index'
import pages from './pages'

// 处理导航故障
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: pages.index
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (login.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: pages.login
  },
  {
    path: '/index_content',
    // name: 'index_content',
    component: pages.index_content,
    children: [
      // 销售管理
      {
        path: '/sale_manage/order_list',
        name: 'order_list',
        component: pages.order_list
      },
      {
        path: '/sale_manage/bill_list',
        name: 'bill_list',
        component: pages.bill_list
      },
      {
        path: '/sale_manage/book_order',
        name: 'book_order',
        component: pages.book_order
      },
      {
        path: '/sale_manage/pay_flow',
        name: 'pay_flow',
        component: pages.pay_flow
      },
      {
        path: '/sale_manage/book_list',
        name: 'book_list',
        component: pages.book_list
      },
      // 商品管理
      {
        path: '/commodity_manage/commodity_list',
        name: 'commodity_list',
        component: pages.commodity_list
      },
      {
        path: '/commodity_manage/commodity_package_list',
        name: 'commodity_package_list',
        component: pages.commodity_package_list
      },
      {
        path: '/commodity_manage/commodity_distribt',
        name: 'commodity_distribt',
        component: pages.commodity_distribt
      },
      {
        path: '/commodity_manage/package_name',
        name: 'package_name',
        component: pages.package_name
      },
      {
        path: '/commodity_manage/package_price',
        name: 'package_price',
        component: pages.package_price
      },
      {
        path: '/commodity_manage/timing_package',
        name: 'timing_package',
        component: pages.timing_package
      },
      {
        path: '/commodity_manage/setting_package',
        name: 'setting_package',
        component: pages.setting_package
      },
      {
        path: '/commodity_manage/commodity_snack',
        name: 'commodity_snack',
        component: pages.commodity_snack
      },
      {
        path: '/commodity_manage/price_strategy',
        name: 'price_strategy',
        component: pages.price_strategy
      },
      {
        path: '/commodity_manage/point_exchange',
        name: 'point_exchange',
        component: pages.point_exchange
      },
      {
        path: '/commodity_manage/self_roll_set',
        name: 'self_roll_set',
        component: pages.self_roll_set
      },
      {
        path: '/commodity_manage/commodity_free_rule',
        name: 'commodity_free_rule',
        component: pages.commodity_free_rule
      },
      {
        path: '/commodity_manage/flower_manage',
        name: 'flower_manage',
        component: pages.flower_manage
      },
      {
        path: '/commodity_manage/commodity_must_order',
        name: 'commodity_must_order',
        component: pages.commodity_must_order
      },
      // 仓库管理
      {
        path: "/stock_management/store_getStoreList",
        name: "store_getStoreList",
        component: pages.store_getStoreList
      },
      {
        path: "/stock_management/store_getStoreProduceList",
        name: "store_getStoreProduceList",
        component: pages.store_getStoreProduceList
      },
      {
        path: "/stock_management/supplier_management",
        name: "supplier_management",
        component: pages.supplier_management
      },
      {
        path: "/stock_management/purchasing",
        name: "purchasing",
        component: pages.purchasing
      },
      {
        path: "/stock_management/procurement_return",
        name: "procurement_return",
        component: pages.procurement_return
      },
      {
        path: "/stock_management/stock_getExchangeStockList",
        name: "stock_getExchangeStockList",
        component: pages.stock_getExchangeStockList
      },
      {
        path: "/stock_management/reported_loss",
        name: "reported_loss",
        component: pages.reported_loss
      },
      {
        path: "/stock_management/stock_receipts",
        name: "stock_receipts",
        component: pages.stock_receipts
      },
      {
        path: "/stock_management/stock_checks",
        name: "stock_checks",
        component: pages.stock_checks
      },
      {
        path: "/stock_management/actual_stock",
        name: "actual_stock",
        component: pages.actual_stock
      },
      {
        path: "/stock_management/deposit_manage",
        name: "deposit_manage",
        component: pages.deposit_manage
      },
      {
        path: "/stock_management/shipment_set",
        name: "shipment_set",
        component: pages.shipment_set
      },
      // 报表
      // {
      //   path: "/finance_report/business_report",
      //   name: "business_report",
      //   component: pages.business_report
      // },
      {
        path: "/finance_report/business_report/zm_report",
        name: "zm_report",
        component: pages.zm_report
      },
      {
        path: "/finance_report/business_report/zh_report",
        name: "zh_report",
        component: pages.zh_report
      },
      {
        path: "/finance_report/business_report/dm_report",
        name: "dm_report",
        component: pages.dm_report
      },
      {
        path: "/finance_report/business_report/dh_report",
        name: "dh_report",
        component: pages.dh_report
      },
      {
        path: "/finance_report/business_report/ys_report",
        name: "ys_report",
        component: pages.ys_report
      },
      {
        path: "/finance_report/business_report/xy_report",
        name: "xy_report",
        component: pages.xy_report
      },
      {
        path: "/finance_report/business_report/jls_report",
        name: "jls_report",
        component: pages.jls_report
      },
      {
        path: "/finance_report/business_report/jld_report",
        name: "jld_report",
        component: pages.jld_report
      },
      {
        path: "/finance_report/business_report/sjm_report",
        name: "sjm_report",
        component: pages.sjm_report
      },
      {
        path: "/finance_report/business_report/sjh_report",
        name: "sjh_report",
        component: pages.sjh_report
      },
      {
        path: "/finance_report/business_report/gzm_report",
        name: "gzm_report",
        component: pages.gzm_report
      },
      {
        path: "/finance_report/business_report/dym_report",
        name: "dym_report",
        component: pages.dym_report
      },
      {
        path: "/finance_report/business_report/dyh_report",
        name: "dyh_report",
        component: pages.dyh_report
      },
      {
        path: "/finance_report/business_report/bxf_report",
        name: "bxf_report",
        component: pages.bxf_report
      },
      {
        path: "/finance_report/business_report/balance_report",
        name: "balance_report",
        component: pages.balance_report
      },
      {
        path: "/finance_report/business_report/timefee_detail_report",
        name: "timefee_detail_report",
        component: pages.timefee_detail_report
      },
      {
        path: "/finance_report/business_report/wine_servicefee_report",
        name: "wine_servicefee_report",
        component: pages.wine_servicefee_report
      },
      {
        path: "/finance_report/business_report/balance_business_report",
        name: "balance_business_report",
        component: pages.balance_business_report
      },
      {
        path: "/finance_report/business_report/zxm_report",
        name: "zxm_report",
        component: pages.zxm_report
      },
      {
        path: "/finance_report/business_report/business_income_day_report",
        name: "business_income_day_report",
        component: pages.business_income_day_report
      },
      {
        path: "/finance_report/others_report/or_song_month_report",
        name: "or_song_month_report",
        component: pages.or_song_month_report
      },
      // {
      //   path: "/finance_report/store_report",
      //   name: "store_report",
      //   component: pages.store_report
      // },
      {
        path: "/finance_report/store_report/sr_ksm_report",
        name: "sr_ksm_report",
        component: pages.sr_ksm_report
      },
      {
        path: "/finance_report/store_report/sr_ksh_report",
        name: "sr_ksh_report",
        component: pages.sr_ksh_report
      },
      {
        path: "/finance_report/store_report/sr_cgm_report",
        name: "sr_cgm_report",
        component: pages.sr_cgm_report
      },
      {
        path: "/finance_report/store_report/sr_cgh_report",
        name: "sr_cgh_report",
        component: pages.sr_cgh_report
      },
      {
        path: "/finance_report/store_report/sr_sym_report",
        name: "sr_sym_report",
        component: pages.sr_sym_report
      },
      {
        path: "/finance_report/store_report/sr_syh_report",
        name: "sr_syh_report",
        component: pages.sr_syh_report
      },
      {
        path: "/finance_report/store_report/sr_jxc_report",
        name: "sr_jxc_report",
        component: pages.sr_jxc_report
      },
      {
        path: "/finance_report/store_report/sr_pxm_report",
        name: "sr_pxm_report",
        component: pages.sr_pxm_report
      },
      // {
      //   path: "/finance_report/member_report",
      //   name: "member_report",
      //   component: pages.member_report
      // },
      {
        path: "/finance_report/member_report/mr_hcz_report",
        name: "mr_hcz_report",
        component: pages.mr_hcz_report
      },
      {
        path: "/finance_report/member_report/mr_hbf_report",
        name: "mr_hbf_report",
        component: pages.mr_hbf_report
      },
      {
        path: "/finance_report/member_report/mr_hzl_report",
        name: "mr_hzl_report",
        component: pages.mr_hzl_report
      },
      {
        path: "/finance_report/member_report/mr_hkb_report",
        name: "mr_hkb_report",
        component: pages.mr_hkb_report
      },
      {
        path: "/finance_report/member_report/mr_hxm_report",
        name: "mr_hxm_report",
        component: pages.mr_hxm_report
      },
      {
        path: "/finance_report/member_report/mr_hsr_report",
        name: "mr_hsr_report",
        component: pages.mr_hsr_report
      },
      {
        path: "/finance_report/member_report/mr_yhx_report",
        name: "mr_yhx_report",
        component: pages.mr_yhx_report
      },
      {
        path: "/finance_report/member_report/mr_hcx_report",
        name: "mr_hcx_report",
        component: pages.mr_hcx_report
      },
      {
        path: "/finance_report/member_report/mr_hjm_report",
        name: "mr_hjm_report",
        component: pages.mr_hjm_report
      },
      {
        path: "/finance_report/member_report/mr_hjh_report",
        name: "mr_hjh_report",
        component: pages.mr_hjh_report
      },
      {
        path: "/finance_report/member_report/mr_ggzl_report",
        name: "mr_ggzl_report",
        component: pages.mr_ggzl_report
      },
      {
        path: "/finance_report/member_report/mr_ggky_report",
        name: "mr_ggky_report",
        component: pages.mr_ggky_report
      },
      {
        path: "/finance_report/member_report/mr_ggfm_report",
        name: "mr_ggfm_report",
        component: pages.mr_ggfm_report
      },
      {
        path: "/finance_report/member_report/mr_ggtm_report",
        name: "mr_ggtm_report",
        component: pages.mr_ggtm_report
      },
      {
        path: "/finance_report/member_report/mr_hjlm_report",
        name: "mr_hjlm_report",
        component: pages.mr_hjlm_report
      },
      {
        path: "/finance_report/member_report/mr_hjltm_report",
        name: "mr_hjltm_report",
        component: pages.mr_hjltm_report
      },
      {
        path: "/finance_report/member_report/mr_hlbgx_report",
        name: "mr_hlbgx_report",
        component: pages.mr_hlbgx_report
      },
      {
        path: "/finance_report/member_report/mr_yejz_report",
        name: "mr_yejz_report",
        component: pages.mr_yejz_report
      },
      {
        path: "/finance_report/member_report/mr_level_change_report",
        name: "mr_level_change_report",
        component: pages.mr_level_change_report
      },
      // {
      //   path: "/finance_report/Wine_access_report",
      //   name: "Wine_access_report",
      //   component: pages.Wine_access_report
      // },
      {
        path: "/finance_report/Wine_access_report/war_jcm_report",
        name: "war_jcm_report",
        component: pages.war_jcm_report
      },
      {
        path: "/finance_report/Wine_access_report/war_jch_report",
        name: "war_jch_report",
        component: pages.war_jch_report
      },
      {
        path: "/finance_report/Wine_access_report/war_qjm_report",
        name: "war_qjm_report",
        component: pages.war_qjm_report
      },
      {
        path: "/finance_report/Wine_access_report/war_qjh_report",
        name: "war_qjh_report",
        component: pages.war_qjh_report
      },
      {
        path: "/finance_report/Wine_access_report/war_cgm_report",
        name: "war_cgm_report",
        component: pages.war_cgm_report
      },
      {
        path: "/finance_report/Wine_access_report/war_cgh_report",
        name: "war_cgh_report",
        component: pages.war_cgh_report
      },
      {
        path: "/finance_report/Wine_access_report/war_cqh_report",
        name: "war_cqh_report",
        component: pages.war_cqh_report
      },
      {
        path: "/finance_report/Wine_access_report/war_jcj_report",
        name: "war_jcj_report",
        component: pages.war_jcj_report
      },
      {
        path: "/finance_report/Wine_access_report/war_yqh_report",
        name: "war_yqh_report",
        component: pages.war_yqh_report
      },
      {
        path: "/finance_report/Wine_access_report/war_jczfm_report",
        name: "war_jczfm_report",
        component: pages.war_jczfm_report
      },
      // {
      //   path: "/finance_report/goods_sales_report",
      //   name: "goods_sales_report",
      //   component: pages.goods_sales_report
      // },
      {
        path: "/finance_report/goods_sales_report/gsr_sxm_report",
        name: "gsr_sxm_report",
        component: pages.gsr_sxm_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_sxh_report",
        name: "gsr_sxh_report",
        component: pages.gsr_sxh_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_stm_report",
        name: "gsr_stm_report",
        component: pages.gsr_stm_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_sth_report",
        name: "gsr_sth_report",
        component: pages.gsr_sth_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_szh_report",
        name: "gsr_szh_report",
        component: pages.gsr_szh_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_stxm_report",
        name: "gsr_stxm_report",
        component: pages.gsr_stxm_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_stxh_report",
        name: "gsr_stxh_report",
        component: pages.gsr_stxh_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_ttxm_report",
        name: "gsr_ttxm_report",
        component: pages.gsr_ttxm_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_ttxh_report",
        name: "gsr_ttxh_report",
        component: pages.gsr_ttxh_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_szm_report",
        name: "gsr_szm_report",
        component: pages.gsr_szm_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_cph_report",
        name: "gsr_cph_report",
        component: pages.gsr_cph_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_ktxm_report",
        name: "gsr_ktxm_report",
        component: pages.gsr_ktxm_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_ktxh_report",
        name: "gsr_ktxh_report",
        component: pages.gsr_ktxh_report
      },
      {
        path: "/finance_report/goods_sales_report/gsr_smzm_report",
        name: "gsr_smzm_report",
        component: pages.gsr_smzm_report
      },
      // {
      //   path: "/finance_report/waiter_report",
      //   name: "waiter_report",
      //   component: pages.waiter_report
      // },
      {
        path: "/finance_report/waiter_report/wr_ytkm_report",
        name: "wr_ytkm_report",
        component: pages.wr_ytkm_report
      },
      {
        path: "/finance_report/waiter_report/wr_ytc_report",
        name: "wr_ytc_report",
        component: pages.wr_ytc_report
      },
      {
        path: "/finance_report/waiter_report/wr_ytlh_report",
        name: "wr_ytlh_report",
        component: pages.wr_ytlh_report
      },
      {
        path: "/finance_report/waiter_report/wr_ybm_report",
        name: "wr_ybm_report",
        component: pages.wr_ybm_report
      },
      {
        path: "/finance_report/waiter_report/wr_ybh_report",
        name: "wr_ybh_report",
        component: pages.wr_ybh_report
      },
      {
        path: "/finance_report/waiter_report/wr_ydm_report",
        name: "wr_ydm_report",
        component: pages.wr_ydm_report
      },
      {
        path: "/finance_report/waiter_report/wr_ydh_report",
        name: "wr_ydh_report",
        component: pages.wr_ydh_report
      },
      {
        path: "/finance_report/waiter_report/wr_yzl_report",
        name: "wr_yzl_report",
        component: pages.wr_yzl_report
      },
      {
        path: "/finance_report/waiter_report/wr_ytpgm_report",
        name: "wr_ytpgm_report",
        component: pages.wr_ytpgm_report
      },
      {
        path: "/finance_report/waiter_report/wr_ytpsm_report",
        name: "wr_ytpsm_report",
        component: pages.wr_ytpsm_report
      },
      // {
      //   path: "/finance_report/others_report",
      //   name: "others_report",
      //   component: pages.others_report
      // },
      {
        path: "/finance_report/others_report/or_hf_report",
        name: "or_hf_report",
        component: pages.or_hf_report
      },
      {
        path: "/finance_report/others_report/or_xld_report",
        name: "or_xld_report",
        component: pages.or_xld_report
      },
      {
        path: "/finance_report/others_report/or_kj_report",
        name: "or_kj_report",
        component: pages.or_kj_report
      },
      {
        path: "/finance_report/others_report/or_yg_report",
        name: "or_yg_report",
        component: pages.or_yg_report
      },
      {
        path: "/finance_report/others_report/or_fp_report",
        name: "or_fp_report",
        component: pages.or_fp_report
      },
      {
        path: "/finance_report/others_report/or_nff_report",
        name: "or_nff_report",
        component: pages.or_nff_report
      },
      {
        path: "/finance_report/others_report/or_kq_report",
        name: "or_kq_report",
        component: pages.or_kq_report
      },
      {
        path: "/finance_report/others_report/or_gdh_report",
        name: "or_gdh_report",
        component: pages.or_gdh_report
      },
      {
        path: "/finance_report/others_report/or_yxsm_report",
        name: "or_yxsm_report",
        component: pages.or_yxsm_report
      },
      {
        path: "/finance_report/others_report/or_jfdhm_report",
        name: "or_jfdhm_report",
        component: pages.or_jfdhm_report
      },
      {
        path: "/finance_report/others_report/or_jfdhh_report",
        name: "or_jfdhh_report",
        component: pages.or_jfdhh_report
      },
      {
        path: "/finance_report/others_report/or_kyjs_report",
        name: "or_kyjs_report",
        component: pages.or_kyjs_report
      },
      {
        path: "/finance_report/others_report/or_bpsm_report",
        name: "bpsm",
        component: pages.bpsm
      },
      {
        path: "/finance_report/others_report/or_dxfm_report",
        name: "or_dxfm_report",
        component: pages.or_dxfm_report
      },
      {
        path: "/finance_report/others_report/or_treasure_report",
        name: "or_treasure_report",
        component: pages.or_treasure_report
      },
      {
        path: "/finance_report/others_report/or_wx_login_report",
        name: "or_wx_login_report",
        component: pages.or_wx_login_report
      },
      {
        path: "/finance_report/flower_report/flower_detail_report",
        name: "flower_detail_report",
        component: pages.flower_detail_report
      },
      {
        path: "/finance_report/flower_report/flower_total_report",
        name: "flower_total_report",
        component: pages.flower_total_report
      },
      // 商品盈利报表
      {
        path: "/finance_report/goods_profit_report/profit_detail_report",
        name: "profit_detail_report",
        component: pages.profit_detail_report
      },
      {
        path: "/finance_report/goods_profit_report/profit_total_report",
        name: "profit_total_report",
        component: pages.profit_total_report
      },
      {
        path: "/finance_report/goods_profit_report/goodspackage_detail_report",
        name: "goodspackage_detail_report",
        component: pages.goodspackage_detail_report
      },
      {
        path: "/finance_report/goods_profit_report/goodspackage_total_report",
        name: "goodspackage_total_report",
        component: pages.goodspackage_total_report
      },
      {
        path: "/finance_report/goods_profit_report/kfpackage_detail_report",
        name: "kfpackage_detail_report",
        component: pages.kfpackage_detail_report
      },
      {
        path: "/finance_report/goods_profit_report/kfpackage_total_report",
        name: "kfpackage_total_report",
        component: pages.kfpackage_total_report
      },
      {
        path: "/finance_report/ticket_sales_report/tsr_mym_report",
        name: "tsr_mym_report",
        component: pages.tsr_mym_report
      },
      {
        path: "/finance_report/ticket_sales_report/tsr_myh_report",
        name: "tsr_myh_report",
        component: pages.tsr_myh_report
      },
      {
        path: "/finance_report/ticket_sales_report/tsr_gyh_report",
        name: "tsr_gyh_report",
        component: pages.tsr_gyh_report
      },
      {
        path: "/finance_report/ticket_sales_report/tsr_pyh_report",
        name: "tsr_pyh_report",
        component: pages.tsr_pyh_report
      },
      {
        path: "/finance_report/ticket_sales_report/tsr_tjsh_report",
        name: "tsr_tjsh_report",
        component: pages.tsr_tjsh_report
      },
      {
        path: "/finance_report/customer_report/customer_data_report",
        name: "customer_data_report",
        component: pages.customer_data_report
      },
      {
        path: "/finance_report/customer_report/report_system_index",
        name: "report_system_index",
        component: pages.report_system_index,
      },
      // 自助营业额报表
      {
        path: "/finance_report/self-service_business_report/turnover_report",
        name: "turnover_report",
        component: pages.turnover_report
      },
      // 自助营业收入报表
      {
        path: "/finance_report/self-service_business_report/operating_revenue_report",
        name: "operating_revenue_report",
        component: pages.operating_revenue_report
      },
      // 员工管理
      {
        path: "/staff_manage/employee_list",
        name: "employee_list",
        component: pages.employee_list
      },
      {
        path: "/staff_manage/waiter_list",
        name: "waiter_list",
        component: pages.waiter_list
      },
      // 设置
      {
        path: "/system_set/store_list",
        name: "store_list",
        component: pages.store_list
      },
      {
        path: "/system_set/store_set",
        name: "store_set",
        components: {
          business: pages.store_set_business,
          bill: pages.store_set_bill,
          deposit: pages.store_set_deposit,
          vod: pages.store_set_vod,
          store: pages.store_set_store,
          print: pages.store_set_print,
          personnel: pages.store_set_personnel,
          system: pages.store_set_system,
        }
      },
      {
        path: "/system_set/printer_list",
        name: "printer_list",
        component: pages.printer_list
      },
      {
        path: "/system_set/moling_set",
        name: "moling_set",
        component: pages.moling_set
      },
      {
        path: "/system_set/zero_set",
        name: "zero_set",
        component: pages.zero_set
      },
      {
        path: "/system_set/zoumadeng_set",
        name: "zoumadeng_set",
        component: pages.zoumadeng_set
      },
      {
        path: "/system_set/members_send_info_set",
        name: "members_send_info_set",
        component: pages.members_send_info_set
      },
      {
        path: "/system_set/set_rotation_song",
        name: "set_rotation_song",
        component: pages.set_rotation_song
      },
      {
        path: "/system_set/vod_online_set",
        name: "vod_online_set",
        component: pages.vod_online_set
      },
      {
        path: "/system_set/deposit_set",
        name: "deposit_set",
        component: pages.deposit_set
      },
      {
        path: "/system_set/music_set",
        name: "music_set",
        component: pages.music_set
      },
      {
        path: "/system_set/cash_register_set",
        name: "cash_register_set",
        component: pages.cash_register_set
      },
      {
        path: "/system_set/movie_manage",
        name: "movie_manage",
        component: pages.movie_manage
      },
      {
        path: "/system_set/refund_check",
        name: "refund_check",
        component: pages.refund_check
      },
      {
        path: "/system_set/present_check",
        name: "present_check",
        component: pages.present_check
      },
      {
        path: "/system_set/lack_song_set",
        name: "lack_song_set",
        component: pages.lack_song_set
      },
      {
        path: "/system_set/room_type_set",
        name: "room_type_set",
        component: pages.room_type_set
      },
      {
        path: "/system_set/welcome_template",
        name: "welcome_template",
        component: pages.welcome_template
      },
      {
        path: "/system_set/repair_check",
        name: "repair_check",
        component: pages.repair_check
      },
      {
        path: "/system_set/theme_menu_song",
        name: "theme_menu_song",
        component: pages.theme_menu_song
      },
      {
        path: "/system_set/ad_space_set",
        name: "ad_space_set",
        component: pages.ad_space_set
      },
      {
        path: "/system_set/vip_salon",
        name: "vip_salon",
        component: pages.vip_salon
      },
      {
        path: "/system_set/pad_order_set",
        name: "pad_order_set",
        component: pages.pad_order_set
      },
      {
        path: "/system_set/custom_music_manage",
        name: "custom_music_manage",
        component: pages.custom_music_manage
      },
      {
        path: "/system_set/screen_ad_set",
        name: "screen_ad_set",
        component: pages.screen_ad_set
      },
      {
        path: "/system_set/door_plate_set",
        name: "door_plate_set",
        component: pages.door_plate_set
      },
      {
        path: "/system_set/guest_leave_store_apply_set",
        name: "guest_leave_store_apply_set",
        component: pages.guest_leave_store_apply_set
      },
      {
        path: "/system_set/room_give_rule_set",
        name: "room_give_rule_set",
        component: pages.room_give_rule_set
      },
      {
        path: "/system_set/welfare_activity",
        name: "welfare_activity",
        component: pages.welfare_activity,
      },
      {
        path: "/system_set/wx_order_home",
        name: "wx_order_home",
        component: pages["wx_order_home"],
      },
      {
        path: "/system_set/performance_set",
        name: "performance_set",
        component: pages.performance_set,
      },
      {
        path: "/system_set/group_manage",
        name: "group_manage",
        component: pages.group_manage,
      },
      // 套账
      {
        path: "/account_book/account_book_make",
        name: "account_book_make",
        component: pages.account_book_make
      },
      {
        path: "/account_book/account_book_report",
        name: "account_book_report",
        component: pages.account_book_report
      },
      {
        path: "/account_book/account_book_printer",
        name: "account_book_printer",
        component: pages.account_book_printer
      },
      // 门票
      {
        path: "/ticket_system/ticket_manage",
        name: "ticket_manage",
        component: pages["ticket_manage"],
      },
      {
        path: "/ticket_system/bistro_set",
        name: "bistro_set",
        component: pages["bistro_set"],
      },
      {
        path: "/ticket_system/level_manage",
        name: "level_manage",
        component: pages["level_manage"],
      },
      {
        path: "/ticket_system/race_manage",
        name: "race_manage",
        component: pages["race_manage"],
      },
      {
        path: "/ticket_system/turnstile_manage",
        name: "turnstile_manage",
        component: pages["turnstile_manage"],
      },
      {
        path: "/ticket_system/platform_ticket",
        name: "platform_ticket",
        component: pages["platform_ticket"],
      },
      // 自助参数设置
      // KTV参数设置
      {
        path: "/self_service_set/KTV_params_set",
        name: "KTV_params_set",
        component: pages.KTV_params_set,
      },
      {
        path: "/self_service_set/billiards_params_set",
        name: "billiards_params_set",
        component: pages.billiards_params_set,
      },
      {
        path: "/self_service_set/poker_params_set",
        name: "poker_params_set",
        component: pages.poker_params_set,
      },
      {
        path: "/self_service_set/bar_params_set",
        name: "bar_params_set",
        component: pages.bar_params_set,
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 验证身份
router.beforeEach((to, from, next) => {
  if(to.name !== 'login' && !store.state.usermobile) next({ name: 'login' })
  else next()
})
// router.beforeEach((to, from, next) => {
//   if(to.name !== 'login' && !store.state.usermobile) {
//     next({ name: 'login' })
//   } else if(window.location.host.indexOf('localhost') < 0) {
//     // 跳转到登录版本首页
//     if(store.state.versionurl != window.location.href) {
//       window.location.href = store.state.versionurl
//       // next()
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

export default router
